import { useUidAttribute } from "composables/useUidAttribute";
import { useSharedState } from "composables/useSharedState";
import { tableFooterVariants } from "./Table.styles";

export interface TableFooterProps {
  /** Whether the footer sticks to the bottom when the table body scrolls. */
  sticky?: boolean;
}

export interface UseTableFooterOptions {
  props: Readonly<TableFooterProps>;
}

export const useTableFooter = (options: UseTableFooterOptions) => {
  const { props } = options;
  useUidAttribute();
  useSharedState(props);
  const classes = tableFooterVariants(props);
  return { classes };
};
